// EmailJS Configuration
// To set up email functionality:
// 1. Create an account at https://emailjs.com
// 2. Create a new service (Gmail, Outlook, etc.)
// 3. Create an email template with the following variables:
//    - {{to_email}} - support@voy-gr.com
//    - {{from_name}} - User's name/email
//    - {{from_email}} - User's email
//    - {{rating}} - Rating number (1-5)
//    - {{rating_text}} - Rating description
//    - {{comments}} - User comments
//    - {{book_id}} - Book ID
//    - {{path_name}} - Story path
//    - {{user_email}} - User's email
//    - {{timestamp}} - Submission timestamp
// 4. Update the values below with your EmailJS credentials

export const EMAILJS_CONFIG = {
  // Replace with your EmailJS public key
  PUBLIC_KEY: 'lBRCRWN26kekEA9Ns',
  
  // Replace with your EmailJS service ID
  SERVICE_ID: 'service_vfck0ot',
  
  // Replace with your EmailJS template ID  
  TEMPLATE_ID: 'template_kkxl6cs'
};

// Example email template:
/*
Subject: New Feedback - {{book_id}} ({{path_name}} path)

Hello,

New feedback submitted for Voyager:

Book: {{book_id}}
Path: {{path_name}}
Rating: {{rating}}/5 - {{rating_text}}
User Email: {{user_email}}
Submitted: {{timestamp}}

Comments:
{{comments}}

---
Sent via Voyager Feedback System
*/